/**
 * Reclaim · Haptic feedback helper.
 *
 * Wraps `navigator.vibrate` so we degrade gracefully on browsers /
 * devices that don't support it. iOS Safari does NOT support the
 * Vibration API — but on iOS the tactile confirmation comes from the
 * UI's pulse animation instead (see the Rhythm Map cell transition).
 *
 * Never throws, never blocks, never awaits.
 *
 * Patterns are intentionally short (10–35ms). Long buzzes feel
 * uncanny; brief ticks feel like a physical click.
 */

const PATTERNS = {
  tick:    12,           // single short pulse — for check-ins / tick actions
  pop:     18,           // slightly heavier — for confirmations
  success: [14, 40, 14], // two-tap — for completions
  error:   [10, 50, 10, 50, 10], // stutter — for failures
};

export function haptic(kind = "tick") {
  try {
    if (typeof navigator === "undefined") return;
    if (typeof navigator.vibrate !== "function") return;
    const pattern = PATTERNS[kind] ?? PATTERNS.tick;
    navigator.vibrate(pattern);
  } catch (_) {
    /* silent — never let haptics break the parent flow */
  }
}

// Convenience shortcuts.
export const hapticTick    = () => haptic("tick");
export const hapticPop     = () => haptic("pop");
export const hapticSuccess = () => haptic("success");
export const hapticError   = () => haptic("error");
